module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-es-ES.d3ab8274.jpg";